import React from "react";
import '../Styles/GroupReservationTypeSelection.scss';
import { GroupPageOptions } from "../Constants/RegistrationPageOptions";

// The retreat group flow passes its own page constants in. They currently carry the same string
// values as GroupPageOptions, but defaulting here keeps the overnight camp flow working unchanged
// while letting either caller drive navigation explicitly.
const GroupReservationTypeSelection = ({ selectedPage, setSelectedPage, isFastTrack, setIsFastTrack,
   nextPage = GroupPageOptions.ReservationSpotSelection,
   previousPage = GroupPageOptions.WeekSelection }) => {

   const NavigateFastTrackReservation = () => {
      setIsFastTrack(true)
      setSelectedPage(nextPage)
   }
   const NavigateStandardReservation = () => {
      setIsFastTrack(false)
      setSelectedPage(nextPage)
   }
   function PrevPage(event) {
      event.preventDefault()
      setSelectedPage(previousPage)
   }

   return (
      <div className="groupReservationTypeSelectionContainer">
         <div className="groupReservationTypeSelectionContent">
            <div className="groupReservationTypeSelectionHeading">
               Select a Reservation Type
            </div>
            <div className="groupReservationTypeSelectionSubHeading">
               Hold spots for your group now. Upgrade to Fast Track for a longer hold and added perks.
            </div>

            <div className="groupReservationTierGrid">
               {/* Standard — the free baseline tier */}
               <div className="groupReservationTierCard">
                  <div className="groupReservationTierName">
                     Standard
                  </div>
                  <div className="groupReservationTierPrice">
                     <span className="groupReservationTierAmount">$0</span>
                     <span className="groupReservationTierPeriod">no reservation fee</span>
                  </div>
                  <div className="groupReservationTierTagline">
                     Reserve spots for your group at no cost.
                  </div>
                  <div className="groupReservationTierDivider"></div>
                  <ul className="groupReservationTierFeatures">
                     <li>Reserve spots for your campers ahead of time</li>
                     <li>A group code your campers register under</li>
                     <li>No cost to hold your reservation</li>
                  </ul>
                  <div className="groupReservationTierAction">
                     <button
                        className="groupReservationTierButtonSecondary"
                        onClick={NavigateStandardReservation}>
                        Choose Standard
                     </button>
                  </div>
               </div>

               {/* Fast Track — the paid upgrade tier */}
               <div className="groupReservationTierCard groupReservationTierCardPremium">
                  <div className="groupReservationTierBadge">
                     Most Popular
                  </div>
                  <div className="groupReservationTierName">
                     Fast Track
                  </div>
                  <div className="groupReservationTierPrice">
                     <span className="groupReservationTierAmount">$100</span>
                     <span className="groupReservationTierPeriod">one-time fee</span>
                  </div>
                  <div className="groupReservationTierTagline">
                     Everything in Standard, plus a longer hold and free perks for your group.
                  </div>
                  <div className="groupReservationTierDivider"></div>
                  <ul className="groupReservationTierFeatures">
                     <li>Everything in Standard</li>
                     <li>Spots held until Feb 28 of next year</li>
                     <li>Free week of camp for a church counselor</li>
                     <li>Free cookout ticket</li>
                     <li>Your choice: a second free counselor or a free deluxe room</li>
                  </ul>
                  <div className="groupReservationTierAction">
                     <button
                        className="groupReservationTierButtonPrimary"
                        onClick={NavigateFastTrackReservation}>
                        Choose Fast Track
                     </button>
                     <div className="groupReservationTierFootnote">
                        $100 fee charged at checkout
                     </div>
                  </div>
               </div>
            </div>

            <div className="groupReservationTypeSelectionButtonsContainer">
               <div className="groupReservationTypeSelectionPreviousButton">
                  <button onClick={PrevPage}>
                     Previous
                  </button>
               </div>
            </div>
         </div>
      </div>
   )
}

export default GroupReservationTypeSelection;
